module.exports = __webpack_public_path__ + "static/born-red-a515d651f5b81454af3d3df03172d0bf.jpg";